import React, { useState } from "react";
import { isEmpty, orderBy } from "lodash";
import clsx from "clsx";
// components
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
// type
import { TMainPageLayoutV3 } from "../type";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
// enums
import EViewType from "@/cms/enums/EViewType";
// utilities
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";


const MNPG057 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG057.rendered: ", props);
    
    const [activeTab, setActiveTab] = useState<string>("");

    const toggle = (tab:string) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    if ( 
        !isEmpty(props.params?.parentLanguageVersion) && props.params?.parentLanguageVersion && 
        !isEmpty(props.params?.parentLanguageVersion?.id) && props.params?.parentLanguageVersion?.id && 
        props.params?.parentLanguageVersion?.viewType === EViewType.TAB 
    ) {
        let payloadChild:TLanguageVersionList[]|null = props.params?.languageVersions?.filter((item:TLanguageVersionList) => item.parentId === props.params?.parentLanguageVersion?.id);

        if ( isEmpty(payloadChild) ) return null;

        payloadChild = orderBy(payloadChild, ['order'],['asc']);
        if ( isEmpty(activeTab) ) setActiveTab(payloadChild[0].id);

        return (
            <div className="project-single-tab clearfix">
                <ul className="nav">
                    <Nav tabs>
                        {
                            payloadChild.map((item) => (
                                <NavItem>
                                    <NavLink
                                        className={clsx({ active: activeTab === item.id })}
                                        onClick={() => { toggle(item.id); }}
                                    >
                                        {item.name}
                                    </NavLink>
                                </NavItem>
                            ))
                        }
                    </Nav>
                </ul>

                <TabContent activeTab={activeTab}>
                    {
                        payloadChild.map((item) => (
                            <TabPane tabId={item.id}>
                                <RMDRComponentSanitizer
                                    languageVersion={item}
                                    variant="div"
                                    valueExpr="value"
                                />
                            </TabPane>
                        ))
                    }
                </TabContent>
            </div>
        )
    }

    return null;
}

export default MNPG057;
